import { Injectable } from "@angular/core";
import { NgbDatepickerConfig } from "@ng-bootstrap/ng-bootstrap";

@Injectable()
export class NgbCustomDatePickerConfig extends NgbDatepickerConfig {
    firstDayOfWeek = 7;
}
